import { RedoShopifyCountryCode } from "@redotech/redo-model/fulfillments/fulfillment-country-code";
import * as z from "zod/v4";

const LabelMarkupEntry_ = z.object({
  origin: z.enum(RedoShopifyCountryCode),
  destination: z.enum(RedoShopifyCountryCode),
  markup: z.number(),
});
export const LabelMarkupEntry: z.ZodType<LabelMarkupEntry> = LabelMarkupEntry_;
export interface LabelMarkupEntry extends z.infer<typeof LabelMarkupEntry_> {}

export const getReturnBearIntegration = {
  name: "getReturnBearIntegration" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    integration: z.optional(
      z.object({
        enabled: z.boolean(),
        storeId: z.number(),
        dropoffLocationRadiusMiles: z.number(),
        eligibleShopperCountries: z.array(z.enum(RedoShopifyCountryCode)),
        markups: z.array(LabelMarkupEntry),
      }),
    ),
  }),
};

export const updateReturnBearMarkups = {
  name: "updateReturnBearMarkups" as const,
  input: z.object({ teamId: z.string(), markups: z.array(LabelMarkupEntry) }),
  output: z.object({}),
};
